import { Skeleton } from "antd";

export default function TextContentLoading() {
  return (
    <section>
      <Skeleton.Input active className="!h-8 !w-64 mb-6" />
      <div className="space-y-3">
        <Skeleton
          active
          paragraph={{
            rows: 6,
            width: ["100%", "98%", "95%", "100%", "92%", "97%"],
          }}
          title={false}
        />
      </div>
    </section>
  );
}
